import * as React from 'react';
import {
  BrukerApi,
  BrukerApiInterface,
  PraksisstedApi,
  PraksisstedApiInterface,
} from './generated/admin-generated-api';

export interface AdminApiStore {
  brukerApi: BrukerApiInterface;
  praksisstedApi: PraksisstedApiInterface;
}

export const AdminApiContext = React.createContext<AdminApiStore>({
  brukerApi: new BrukerApi(() => {}),
  praksisstedApi: new PraksisstedApi(() => {}),
});
